export default class EmailHelper {

    groupBy(emails, property) {
        return emails.reduce(
            (groupedEmails, email) => {
                (groupedEmails[email[property]] = groupedEmails[email[property]] || []).push(email);
                return groupedEmails;
            },
            {}
        );
    }

}
